export const environment = {
  production: false,
  url: 'https://api-dev.mabe.cc/api/back-mabe',
  googleMapsApiKey: 'AIzaSyBMv12ZSysd4GQlqwPmhl2OFOWu018wnPA',
  siteKey: "6LezG4kqAAAAABduMdpK6DAsFo85Mm6uEt-HgwRd"
};